// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"style_BackButton__UcNBi","text":"style_text__11TxC"};